import { useAuth } from '../contexts/AuthContext';

export const useUserLevel = (level: string) => {
  const { userLevel } = useAuth();

  return userLevel === level ?? true;
};
